function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import { SIGNUP_BUTTON_TYPE, SIGNUP_COMBO_BUTTONS_TYPE, SECONDARY_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import ButtonFieldsConfig from "segments/desktop/core-components/button/fields-config";
import ProductsConfig from "segments/core-configs/products-config";
import AssetFieldsConfig from "components/core/asset/fields-config";
const { options } = ButtonFieldsConfig;
const { image } = AssetFieldsConfig;
const productCardButtonOptions = options.filter((option)=>[
        SIGNUP_BUTTON_TYPE,
        SIGNUP_COMBO_BUTTONS_TYPE,
        SECONDARY_BUTTON_TYPE
    ].includes(option.text));
export default {
    type: FIELD_TYPES.NESTED,
    label: "Product Cards",
    fields: _object_spread_props(_object_spread({}, ThemeConfig), {
        cards: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Card Items",
            maxLimit: 5,
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: _object_spread_props(_object_spread({}, ProductsConfig), {
                    overrideLogo: {
                        type: FIELD_TYPES.NESTED,
                        label: "Override Logo",
                        fields: {
                            image
                        }
                    },
                    isHighlighted: {
                        type: FIELD_TYPES.BOOLEAN,
                        label: "Is highlighted"
                    },
                    showOpen: {
                        type: FIELD_TYPES.BOOLEAN,
                        label: "Show card open in mobile version"
                    },
                    header: {
                        type: FIELD_TYPES.NESTED,
                        label: "Header",
                        fields: {
                            subtitleText: {
                                type: FIELD_TYPES.TEXT,
                                label: "Text",
                                translatable: true
                            },
                            mobileSubTitleText: {
                                type: FIELD_TYPES.TEXT,
                                label: "Mobile subtitle text",
                                translatable: true
                            }
                        }
                    },
                    body: {
                        type: FIELD_TYPES.NESTED,
                        label: "Body",
                        fields: {
                            bodyText: {
                                type: FIELD_TYPES.TEXT,
                                label: "Text",
                                translatable: true
                            }
                        }
                    },
                    showDivider: {
                        type: FIELD_TYPES.BOOLEAN,
                        label: "Show divider"
                    },
                    useCases: {
                        type: FIELD_TYPES.NESTED,
                        label: "Use cases",
                        fields: {
                            text: {
                                type: FIELD_TYPES.TEXT,
                                label: "Text",
                                translatable: true
                            },
                            list: {
                                type: FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Use cases list",
                                maxLimit: 6,
                                nestedConfig: {
                                    type: FIELD_TYPES.NESTED,
                                    fields: {
                                        text: {
                                            type: FIELD_TYPES.TEXT,
                                            label: "Text",
                                            translatable: true
                                        }
                                    }
                                }
                            }
                        }
                    },
                    buttonConfig: {
                        type: FIELD_TYPES.CONDITIONAL_NESTED,
                        label: "Button",
                        conditionalKeyName: "buttonType",
                        options: productCardButtonOptions
                    },
                    isV2: {
                        type: FIELD_TYPES.BOOLEAN,
                        label: "Is V2"
                    }
                })
            }
        }
    })
};
